const DialogTransitionProps = { /* https://github.com/dequelabs/axe-core/issues/146 */ role: 'presentation' } as any;
export default DialogTransitionProps;
